export default __webpack_public_path__ + "static/media/ic_quotes.159df24c.svg";